import { render } from "./DateRangepickerComponent.vue?vue&type=template&id=6c3526aa"
import script from "./DateRangepickerComponent.vue?vue&type=script&lang=js"
export * from "./DateRangepickerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/user_ui/taichung_citizen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__